import { fetcher } from '@bino/utils/fetcher';
import { useCallback } from 'react';
import type { Inputs } from '../types';

export const useFeedbackForm = () => {
    const postFeedback = useCallback(async (form: Inputs) => {
        try {
            await fetcher.post('/api/feedback-form', form);
            return { success: true };
        } catch (error) {
            console.error('Error posting feedback form', error);
            return { success: false };
        }
    }, []);

    return {
        postFeedback,
    };
};
